import { useNavigate } from "react-router-dom";
import { useState } from "react";
import defaultAxios from 'axios';
import { AddProgramDescriptionTab } from "./addProgramDescriptionTab";
import { AddParameterTab } from "./addParameterTab";
import { useAuth } from "../../../AuthContext";
import { backendUrl } from "../../../common/constantVarialble";
import CodeEditor from '@uiw/react-textarea-code-editor';

interface ProgramDepthParent {
    code: string;
    p_code: string;
    depth: number;
}


const AddProgramPage = ({ programDepthParent }: { programDepthParent: ProgramDepthParent | null }) => {

    const { user, userName } = useAuth();

    interface prgInfo {
        depth?: string;
        p_code?: string;
        program_id?: string;
        prg_description?: string;
        sql?: string;
        input_date?: string;
        input_psn?: string;
        update_knd?: string;
        rollback_seq?: string;
        commit_msg?: string;
    }

    interface PrmInfo {
        param_name?: string;
        param_seq?: string;
    }

    const [programInfo, setProgramInfo] = useState<prgInfo | null>({
        depth: programDepthParent?.depth + "",
        p_code: programDepthParent?.p_code,
        program_id: "",
        prg_description: "",
        sql: "",
        input_date: "",
        input_psn: userName ?? "",
        update_knd: "U",
        rollback_seq: "-1",
        commit_msg: ""
    });
    const [parameterInfo, setParameterInfo] = useState<PrmInfo[]>([]);

    const navigate = useNavigate();
    const onBack = () => {
        navigate("/admin/sql");
    }

    const PARAMETER = "parameter";
    const HISTORY = "hisotry";
    const DESCRIPTION = "description";
    const TEST = "test";
    const [programDetailMenu, setProgramDetailMenu] = useState(DESCRIPTION);

    const [programCreated, setProgramCreated] = useState(false); // 새 프로그램이 저장되었는지 여부

    const programDetailTabClick = (menu: string) => {
        if (menu === programDetailMenu) {
            return
        } else {
            console.log("Menu In", menu);

            setProgramDetailMenu(menu);
        }
    }

    const onPushClick = async () => {

        console.log("push", programInfo);
        console.log("param", parameterInfo);

        const paramString = parameterInfo.map((p) => p.param_name).join(",");

        if (!programInfo?.program_id?.trim()) {
            alert("Enter PROGRAM_ID");
            return;
        }

        if (!programInfo?.sql?.trim()) {
            alert("Enter SQL");
            return;
        }

        if (!programInfo?.p_code?.trim()) {
            alert("Parent Code Error");
            return;
        }

        if (!programInfo?.commit_msg?.trim()) {
            alert("Enter commit message");
            return;
        }


        const { data } = await defaultAxios({
            method: 'post',
            //url: 'http://localhost:5000/api/request/',
            url: backendUrl,
            data: {
                program_id: 'PERCENT-ADMIN-PRG-C-CRTPRGPRM',
                params: {
                    'p_program_id': programInfo?.program_id,
                    'p_param_list': paramString,
                    'p_prg_description': programInfo?.prg_description,
                    'p_sql': programInfo?.sql,
                    'p_input_psn': userName,
                    'p_commit_msg': programInfo?.commit_msg,
                    'p_parent_code': programInfo?.p_code
                },
                page_index: -1,
            },
        });

        if (data.ok) {
            alert("프로그램이 정상적으로 저장되었습니다.");
            setProgramCreated(true);
            // programDetail 페이지로 이동하면서 현재 페이지를 히스토리에서 삭제 - React-router-dom V6
            navigate(`/admin/sql/program?program_id=${programInfo?.program_id}`, { replace: true });
        }


        return data;
    }


    return (
        <div className="flex flex-1 flex-row h-screen bg-gray-700 px-8 py-6 items-center space-x-4 overflow-hidden">
            <div className="flex flex-col flex-1 h-full">
                <div className="flex flex-row justify-between my-4">
                    <span className="text-2xl text-white h-2">Create a new program</span>
                    <span className="text-xl text-cyan-300">{programInfo?.p_code}</span>
                </div>
                <div>Auto generate</div>
                <div className="flex justify-end my-2 items-center space-x-6">
                    <input
                        className="appearance-none border-none block w-full rounded bg-slate-400 bg-opacity-50 p-2 leading-tight outline-none text-white focus:bg-opacity-100 transition-all duration-300" id="nick" type="text" placeholder="Enter commit message..."
                        disabled={programCreated}
                        value={programInfo?.commit_msg}
                        onChange={(e) => setProgramInfo({ ...programInfo, commit_msg: e.target.value })}
                    />

                    <button className="group relative h-10 w-40 overflow-hidden rounded-lg bg-indigo-500 text-lg font-bold text-white" onClick={onPushClick}>
                        Push
                        <div className="absolute inset-0 h-full w-full scale-0 rounded-lg transition-all duration-300 group-hover:scale-100 group-hover:bg-white/30"></div>
                    </button>

                </div>
                <div className="flex flex-row bg-[#2B2D30] h-full border-gray-500 border-t">
                    <div className="flex flex-col w-3/5">
                        <span className="bg-black bg-opacity-70 italic text-white px-4 py-2 border-b border-gray-500 text-sm">.SQL</span>
                        <div className="flex-1 overflow-auto">
                            <CodeEditor
                                value={programInfo?.sql}
                                language="sql" // Change the language to PostgreSQL
                                placeholder="Please enter SQL code."
                                onChange={(e) => setProgramInfo({ ...programInfo, sql: e.target.value })}
                                padding={15}
                                style={{
                                    backgroundColor: "#2B2D30", // Darker background for better contrast
                                    color: "#B9BBBF", // White text
                                    fontFamily: 'Fira Code, monospace',
                                    fontSize: '14px', // Increase font size for readability
                                    border: 'none', // Remove the border
                                    overflowY: 'auto', // Enable vertical scrolling
                                    //height: '100%', // Full height for the editor
                                    width: '100%'
                                }}
                            />
                        </div>
                        <textarea
                            className="flex w-full h-1/4 p-4 bg-black text-body border-none resize-none focus:outline-none"
                            style={{ whiteSpace: 'pre-line' }}
                            value={'percent/test/result>_'}
                            onChange={(e) => { }}
                        />
                    </div>
                    <div className="flex flex-col w-2/5 bg-gray-700">


                        <div className=" bg-gray-700 border-gray-700  px-4 w-full">
                            <ul className="flex items-center gap-2 text-sm font-medium">
                                <li className="flex-1 cursor-pointer px-6" onClick={() => programDetailTabClick(DESCRIPTION)}>
                                    <span
                                        className={` relative flex items-center justify-center gap-2 px-3 py-2 border-b-2  ${programDetailMenu === DESCRIPTION ? " border-b-white  text-white " : "border-b-transparent text-gray-400 hover:border-b-2 hover:border-b-gray-400 hover:text-gray-400 "}`}
                                    >
                                        Description
                                    </span>
                                </li>
                                <li className="flex-1 cursor-pointer px-6" onClick={() => programDetailTabClick(PARAMETER)}>
                                    <span
                                        className={` relative flex items-center justify-center gap-2 px-3 py-2 border-b-2  ${programDetailMenu === PARAMETER ? " border-b-white  text-white " : "border-b-transparent text-gray-400 hover:border-b-2 hover:border-b-gray-400 hover:text-gray-400 "}`}
                                    >
                                        Parameter
                                    </span>
                                </li>
                                {programCreated ??
                                    <li className="flex-1 cursor-pointer px-6" onClick={() => programDetailTabClick(HISTORY)}>
                                        <span
                                            className={` relative flex items-center justify-center gap-2 px-3 py-2 border-b-2  ${programDetailMenu === HISTORY ? " border-b-white  text-white " : "border-b-transparent text-gray-400 hover:border-b-2 hover:border-b-gray-400 hover:text-gray-400 "}`}
                                        >
                                            COMMITS
                                        </span>
                                    </li>
                                }
                                {programCreated ??
                                    <li className="flex-1 cursor-pointer px-6" onClick={() => programDetailTabClick(TEST)}>
                                        <span
                                            className={` relative flex items-center justify-center gap-2 px-3 py-2 border-b-2  ${programDetailMenu === TEST ? " border-b-white  text-white " : "border-b-transparent text-gray-400 hover:border-b-2 hover:border-b-gray-400 hover:text-gray-400 "}`}
                                        >
                                            Test
                                        </span>
                                    </li>
                                }


                            </ul>
                        </div>
                        <div className={`${programDetailMenu === DESCRIPTION ? "visible" : "hidden"} flex-1`}>
                            {programInfo && <AddProgramDescriptionTab prgInfo={programInfo} setProgramInfo={setProgramInfo} programCreated={programCreated} />}
                        </div>
                        <div className={`${programDetailMenu === PARAMETER ? "visible" : "hidden"} flex-1`}>
                            <AddParameterTab prmInfo={parameterInfo} setPrmInfo={setParameterInfo} />
                        </div>



                    </div>
                </div>


            </div>
        </div>
    );
}

export default AddProgramPage;